import { useEffect, useRef } from "react"
import { GlobalMachineContext } from "../../../study-plans/pages/StudyPlansInit/StudyPlansInit"
import { matchPath, useLocation } from "react-router"
import {
  BASE_PATH,
  STUDY_PLAN_V2_SUBPAGE_TARGET_MAP
} from "../../../study-plans/pages/StudyPlansV2/constants"
import { getSPV2RedirectSubpage } from "../../../machines/studyPlan/studyPlanV2/actions"
import { StudyPlanTargets } from "../../../machines/studyPlan/types"

const getDefaultStudyPlanV2Target = (
  subject?: string | null
): StudyPlanTargets => {
  if (subject) {
    return StudyPlanTargets.ProgressByContent
  }

  return StudyPlanTargets.Progress
}

const getTargetBySubpage = (subpage: string, subject: string) => {
  if (!!STUDY_PLAN_V2_SUBPAGE_TARGET_MAP[subpage]) {
    return STUDY_PLAN_V2_SUBPAGE_TARGET_MAP[subpage]
  }

  if (subpage === "edit") {
    return StudyPlanTargets.Edit
  }

  if (subpage === "view") {
    return StudyPlanTargets.ViewRecommended
  }

  return getDefaultStudyPlanV2Target(subject)
}

export const useSPV2NavSync = () => {
  const location = useLocation()
  const currentPathname = location.pathname

  const prevLocationRef = useRef(location.pathname)

  const { user, subject, currentTarget, isStudyPlanV2Enabled } =
    GlobalMachineContext.useSelector(state => ({
      user: state.context.user,
      subject: state.context.subject,
      currentTarget: state.context.currentTarget,
      isStudyPlanV2Enabled: state.context.isStudyPlanV2Enabled
    }))
  const { send } = GlobalMachineContext.useActorRef()

  useEffect(() => {
    if (!isStudyPlanV2Enabled) {
      return
    }

    if (location.pathname !== prevLocationRef.current) {
      const match = matchPath<{ subpage?: string }>(currentPathname, {
        path: `${BASE_PATH}/:subpage?`,
        exact: true
      })

      if (getSPV2RedirectSubpage(currentTarget) !== match.params.subpage) {
        const updatedTarget = getTargetBySubpage(match.params.subpage, subject)

        send({ type: "SELECT_SP_V2_SUBPAGE", target: updatedTarget })
      }

      prevLocationRef.current = location.pathname
    }
  }, [isStudyPlanV2Enabled, currentPathname])
}
